// Ключи кэша хайлайтов (ключи `$api` — `[method, path, init]`): раздел «Хайлайты» и полоса
// на главной читают сводку, строка в разборе — хайлайты его матча. Префикс второго
// ключа без `init` покрывает все разборы.
export const HIGHLIGHTS_OVERVIEW_QUERY_KEY = ["get", "/api/highlights"] as const;
export const ANALYSIS_HIGHLIGHTS_QUERY_KEY = [
  "get",
  "/api/highlights/analyses/{analysis_id}",
] as const;
